/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
'use strict';

var HelperClass = function(helper) {
    this.helper = helper;
};

HelperClass.prototype.getMixin = function() {
    return Odigeo._.clone(this.helper);
};

HelperClass.prototype.extend = function(obj) {
    return Odigeo._.extend({}, this.helper, obj);
};

module.exports = HelperClass;
